module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon5.e1ef904f.svg";